
import { EventMetadata } from "./EventMetadata";
import { EventStatusSection } from "./EventStatusSection";
import { EventDescription } from "./EventDescription";
import { EventRecommendations } from "./types";

interface CardContentProps {
  date: string | null;
  location: string;
  status: string;
  locationType: 'specific' | 'flexible';
  flexibleLocationDescription?: string;
  preferredDates?: Date[];
  preferredVenues?: string[];
  guests: number;
  archived: boolean;
  onArchiveToggle?: () => void;
  recommendations?: EventRecommendations;
  description?: string;
  eventId: string;
  showDescription?: boolean;
}

export const CardContent = ({
  date,
  location,
  status,
  locationType,
  flexibleLocationDescription,
  preferredDates,
  preferredVenues,
  guests,
  archived,
  onArchiveToggle,
  recommendations,
  description,
  eventId,
  showDescription = false,
}: CardContentProps) => {
  // Check if we have metadata content to display
  const isConfirmed = status === 'confirmed' || status === 'booked';
  const hasMetadataContent = showDescription || isConfirmed;
  
  // Check if we have archive controls
  const hasArchiveControls = !!onArchiveToggle;

  // If there's nothing to display, return null to avoid empty space
  if (!hasMetadataContent && !hasArchiveControls) {
    return null;
  }

  return (
    <div className="p-4">
      {/* Description section */}
      <EventDescription description={description} showInCard={showDescription} />
      
      {/* Event metadata section - only render if there's content */}
      {hasMetadataContent && (
        <EventMetadata
          date={date}
          location={location}
          status={status}
          locationType={locationType}
          flexibleLocationDescription={flexibleLocationDescription}
          preferredDates={preferredDates}
          preferredVenues={preferredVenues}
          description={showDescription ? description : undefined}
        />
      )}
      
      {/* Status and actions section - only render if there are archive controls */}
      {hasArchiveControls && (
        <div className="mt-3">
          <EventStatusSection 
            status={status} 
            archived={archived} 
            onArchiveToggle={onArchiveToggle} 
          />
        </div>
      )}
    </div>
  );
};
